import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: 'ng-template[appTabContent]',
    standalone: false
})
export class ContentDirective {
    public constructor(public templateRef: TemplateRef<unknown>) {}
}
